import FuneralInfo from './FuneralInfo'
import ImageAndMessage from './ImageAndMessage'
import ImageOnly from './ImageOnly'
import MessageOnly from './MessageOnly'
import QuoteAndMessage from './QuoteAndMessage'
import YoutubeVideo from './YoutubeVideo'

export { FuneralInfo, ImageAndMessage, ImageOnly, QuoteAndMessage, MessageOnly, YoutubeVideo }
